import React, {ReactNode, useEffect, useMemo} from "react";
import {Navigate, useLocation} from "react-router-dom";

type ReachGuardProps = {
  children: ReactNode;
};

const ReachGuard = ({children}: ReachGuardProps) => {
  const {search} = useLocation();
  const queryParams = new URLSearchParams(search);
  const agentTokenParam = queryParams.get("agentToken");

  const agentToken = useMemo<string>(() => {
    return agentTokenParam || localStorage.getItem("agentToken") || "";
  }, [agentTokenParam]);

  useEffect(() => {
    if (agentToken) {
      localStorage.setItem("agentToken", agentToken);
    }
  }, [agentToken]);

  if (!agentToken) {
    return <Navigate to={`/login?from=${encodeURIComponent(window.location.href)}`} replace />;
  }

  return <>{children}</>;
};

export default ReachGuard;
